module.exports = __webpack_public_path__ + "static/media/2019_conf_How_to_Build_Trust _with_Customers.cd7dcb1d.png";